/**
 * Каркас экранов: двухэтажная шапка плюс содержимое маршрута.
 *
 * Слот второго этажа держится в состоянии, а не в ref: порталам нужен именно
 * ререндер после того, как узел появился в DOM. Первый проход детей отдаёт
 * null (см. PageBar), второй попадает в слот.
 */

import { ReactNode, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppHeader from './AppHeader';
import ErrorBoundary from '../ErrorBoundary';
import { PageBarSlotProvider } from './PageBar';

function AppLayout(): ReactNode {
    const [slot, setSlot] = useState<HTMLDivElement | null>(null);
    const location = useLocation();

    return (
        <PageBarSlotProvider value={slot}>
            <AppHeader tier2Ref={setSlot} />
            {/* Граница охватывает только содержимое маршрута: упавший экран
                заменяется заглушкой, а шапка остаётся рабочей — уйти в другой
                раздел можно без перезагрузки страницы.

                key по пути сбрасывает границу при переходе: иначе после сбоя
                заглушка осталась бы висеть и на следующем экране. */}
            <ErrorBoundary key={location.pathname}>
                <Outlet />
            </ErrorBoundary>
        </PageBarSlotProvider>
    );
}

export default AppLayout;
